import { fillPath, getJson, send } from '@/core/api/http'

export type AktivierungStand = {
  drin: boolean
  akte_offen: boolean
  versaeumt: number
  versaeumt_vorher: number
  erster_versaeumter_tag: string | null
  eintritt_am: string | null
  tag: number | null
  verschoben_von: string | null
  verschoben_am: string | null
  aufgaben_offen: number
  unterschrieben: boolean
}

const pfad = (coachingId: string) => fillPath('/vergabe-portal/coaching/{coaching_id}/aktivierung', { coaching_id: coachingId })

export const getAktivierungStand = (coachingId: string): Promise<AktivierungStand> => getJson<AktivierungStand>(pfad(coachingId))
export const inAktivierung = (coachingId: string): Promise<AktivierungStand> => send<AktivierungStand>(pfad(coachingId), { method: 'POST' })
export const ausAktivierung = (coachingId: string): Promise<AktivierungStand> => send<AktivierungStand>(pfad(coachingId), { method: 'DELETE' })
